import type { Meeting } from '@/types/greenroom/meeting.types';
import { Get } from '../helpers';

export function GetGreenroomMeetingData(sessionUuid: string): Promise<Meeting | null> {
  const url = `${import.meta.env.VITE_GREENROOM_API}/v2/greenroom/events/get-session-by-uuid/${sessionUuid}`;
  return Get({
    path: url,
    includeBlToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    // Note: do not use cache, we need to make sure we always fetch latest data so we don't
    // accidentally send stale updates to greeenroom shot feeds
  });
}
